var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"coming"},[_c('div',{staticClass:"coming__banner"},[_vm._v(" 此頁面還在開發中，敬請期待 ")])])
}]

export { render, staticRenderFns }